<div class="file-upload-multiple">    
  <!-- star -->       
  <div class="files-list" *ngFor="let file of filesSingle; let i = index">
    <div class="single-file" [title]="verifyAttachment(file.fileName) ? 'Saved attachment' : 'New attachment' ">
       <div class="info" (click)="downloadAttachment(file.fileName)" [ngClass]="{ infoLink: verifyAttachment(file.fileName) }">
        <span class="fileIcon">
          <owc-icon name="file" family="outlined"></owc-icon>
        </span>
          <span style="margin-left:20px">
          <span class="name">
            {{file?.fileName}}
            <span class="localTag" *ngIf="ackFileFlag">Local</span>
          </span>
          <p class="size">
            {{ formatBytes(file?.fileSize) }}
          </p>
        </span>
      </div>
        <owc-icon *ngIf="!deleteIconDisable" name="delete" family="outlined" (click)="deleteFile(i)" style="cursor: pointer; width: 14px;
        height: 18px;padding-bottom: 9px;"></owc-icon>
    </div>
  </div>
  <!-- end --> 
  <div *ngIf="filesSingle && filesSingle.length === 0"  class="container" dlAppDnd (fileDropped)="onFileDroppedandSelect($event)">
    <input type="file" #fileDropRefMul [id]="'fileDropRefMul-' + feedbackAttachmentId" [disabled]="fileUploadInputDisabled" (change)="onFileDroppedandSelect($event)"  />
    <div class="dl-svg-img"></div>  
    <span>Drag item here or<label [for]="'fileDropRefMul-' + feedbackAttachmentId">Upload</label> the file</span> 
  </div>
</div>

  
